<template>
    <div class="empty-page">
        <img src="../../static/images/empty.png" alt="" style="width: 120px;display: block;margin: 0 auto;padding-top: 100px;">
        <p style="text-align: center;padding-top: 14px;">暂无内容</p>   
    </div>
</template>

<script>
    export default {
        data() {
            return {
               
            }
        },
    }
</script>



// WEBPACK FOOTER //
// src/components/Empty.vue